import * as css from 'css/exports.module.scss';
import './OwnersSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { InitiativeSubSection } from '../general/InitiativeSubSection';
import React from 'react';
import { SonarUser } from '@ui/SonarUser';
import { Space } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { UserAvatarGroup } from '@ui/avatar';
import { When } from 'react-if';
import { useFeatureFlag, useInitiativeReference } from '@hooks';
export const InitiativeOwnersSummary = ({ initiativeId }) => {
    var _a;
    const isEnabled = useFeatureFlag(FeatureFlag.DataDictionary);
    const { ownerIds } = useInitiativeReference(initiativeId);
    if (!isEnabled) {
        return null;
    }
    return (React.createElement(InitiativeSubSection, { bold: true, count: (_a = ownerIds.length) !== null && _a !== void 0 ? _a : 0, icon: React.createElement(TeamOutlined, null), id: 'initiative-owners-summary', title: COPY_SPECIFIC.OWNERS_IMPACTED },
        React.createElement(When, { condition: ownerIds.length },
            React.createElement(Space, { direction: 'vertical', size: Number(css.size8) },
                ownerIds.slice(0, 3).map((id) => React.createElement(SonarUser, { key: id, showTooltip: true, userId: id })),
                React.createElement(UserAvatarGroup, { maxCount: 5, userIds: ownerIds.slice(3) })))));
};
